export var ChatMessagePositionEnum;

(function (ChatMessagePositionEnum) {
  ChatMessagePositionEnum["left"] = "left";
  ChatMessagePositionEnum["right"] = "right";
})(ChatMessagePositionEnum || (ChatMessagePositionEnum = {}));

export var ChatMessageCardItemTypeEnum;

(function (ChatMessageCardItemTypeEnum) {
  ChatMessageCardItemTypeEnum["common"] = "common";
  ChatMessageCardItemTypeEnum["quotePrice"] = "quotePrice";
  ChatMessageCardItemTypeEnum["tipAlertText"] = "tipAlertText";
})(ChatMessageCardItemTypeEnum || (ChatMessageCardItemTypeEnum = {}));